import React from 'react';
import "./About.css";
import { useNavigate } from 'react-router-dom';
import aboutStudioImg from '../assets/AboutStudio_4k.webp';
import { ArrowRight } from 'lucide-react';

const About = () => {
  const navigate = useNavigate();
  return (
    <section id="about" className="about-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" style={{ boxSizing: 'border-box', width: '100%', position: 'relative', zIndex: 1 }}>
        
        {/* Header Section */}
        <div className="text-center mb-16 reveal-left">
          <p className="about-eyebrow">Opulent Architecture • Precision Execution</p>
          <h2 className="about-title">About Sakae Studio</h2>
          <div className="about-gold-rule"></div>
        </div>

        {/* Main Content Grid — min-width:0 prevents grid blowout on mobile */}
        <div className="about-grid mb-16" style={{ minWidth: 0 }}>
          {/* Text Content */}
          <div className="about-glass-card space-y-6 reveal-left">
            <p className="text-lg leading-relaxed text-gray-200">
              <strong className="text-amber-300">Sakae Studio Private Limited</strong> is a premier architectural and engineering consultancy delivering bespoke solutions for high-end residential, commercial, and urban design projects. We specialize in luxury architecture blended with precise execution.
            </p>
            <p className="text-base leading-relaxed text-gray-300">
              As a subsidiary of Technocrats with 34+ years of industry leadership, we inherit deep expertise in civil engineering and project execution. Led by Ar. Sameed Ahmed Khan, our team combines creative vision with technical prowess.
            </p>
            <p className="text-base leading-relaxed text-gray-300">
              From concept to completion, we deliver turnkey solutions covering master planning, approvals, photorealistic 3D visualization, execution, and post-completion management.
            </p>
            
            {/* Key Features Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-4">
              <div className="about-feature-item">
                <div className="about-feature-dot"></div>
                <span>Luxury Architecture</span>
              </div>
              <div className="about-feature-item">
                <div className="about-feature-dot"></div>
                <span>Turnkey Solutions</span>
              </div>
              <div className="about-feature-item">
                <div className="about-feature-dot"></div>
                <span>3D Spatial Visualization</span>
              </div>
              <div className="about-feature-item">
                <div className="about-feature-dot"></div>
                <span>Project Management</span>
              </div>
            </div>
          </div>

          {/* 3D Render Image Frame */}
          <div className="about-img-wrap reveal-right">
            <img
              src={aboutStudioImg}
              alt="Sakae Studio Photorealistic Architectural Workspace"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#021a13]/80 via-transparent to-transparent pointer-events-none" />
            <div className="absolute bottom-6 left-6 right-6 text-white pointer-events-none">
              <span className="text-xs font-mono uppercase tracking-widest text-amber-400">Sakae Design Studio</span>
              <p className="text-sm font-serif italic text-gray-200 mt-1">Where opulent concepts turn into enduring spatial realities.</p>
            </div>
          </div>
        </div>

        {/* Statistics Grid */}
        <div className="about-stats-grid">
          <div className="about-stat-card reveal-depth delay-1">
            <div className="about-stat-num">34+</div>
            <div className="about-stat-label">Years Legacy</div>
            <div className="about-stat-desc">Decades of trusted engineering & architectural leadership</div>
          </div>
          
          <div className="about-stat-card reveal-depth delay-2">
            <div className="about-stat-num">1634+</div>
            <div className="about-stat-label">Projects Delivered</div>
            <div className="about-stat-desc">Successfully completed luxury residential & commercial landmarks</div>
          </div>
          
          <div className="about-stat-card reveal-depth delay-3">
            <div className="about-stat-num">100%</div>
            <div className="about-stat-label">Turnkey Execution</div>
            <div className="about-stat-desc">Complete end-to-end design, planning, & project management</div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="text-center mt-16 reveal-left delay-2">
          <button
            onClick={() => navigate('/start-project')}
            className="btn-gold"
          >
            Start Your Project <ArrowRight size={16} />
          </button>
        </div>

      </div>
    </section>
  );
};

export default About;